import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { ordersAPI } from '../utils/api';
import OrderForm from '../components/OrderForm';

const OrderCreate = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [initialMaterials, setInitialMaterials] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we're duplicating an order
    if (location.state?.duplicateFrom) {
      const orderToDuplicate = location.state.duplicateFrom;
      setIsDuplicate(true);

      // Convert order items to the format expected by OrderForm
      const materials = orderToDuplicate.items.map(item => ({
        materialId: item.materialId || item.material?.id,
        materialCode: item.material?.code || '',
        materialName: item.material?.name || '',
        unit: item.material?.unit || '',
        quantity: item.quantity,
        unitCost: item.unitCost || item.material?.salePrice || 0,
        note: item.note || '',
        hasVat: item.hasVat || false
      }));

      setInitialMaterials(materials);
    }
  }, [location.state]);

  const handleSubmit = async (formData) => {
    setError('');

    if (formData.selectedMaterials.length === 0) {
      setError('กรุณาเพิ่มวัตถุดิบอย่างน้อย 1 รายการ');
      return;
    }

    setLoading(true);

    try {
      const orderData = {
        note: formData.note,
        discountVat: formData.discountVat || 0,
        discountNonVat: formData.discountNonVat || 0,
        items: formData.selectedMaterials.map(item => ({
          materialId: item.materialId,
          quantity: item.quantity,
          unitCost: item.unitCost,
          note: item.note,
          hasVat: item.hasVat || false
        }))
      };

      await ordersAPI.create(orderData);
      alert('ส่งคำขอสั่งซื้อสำเร็จ รอการอนุมัติจากผู้จัดการ');
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'เกิดข้อผิดพลาดในการสร้างคำสั่งซื้อ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="main-content">
      <Row className="mb-4">
        <Col>
          <h2>
            <i className={`bi ${isDuplicate ? 'bi-copy' : 'bi-plus-circle'} me-2`}></i>
            {isDuplicate ? 'คัดลอกคำสั่งซื้อ' : 'ส่งคำขอสั่งซื้อวัตถุดิบ'}
          </h2>
          <p className="text-muted">
            {isDuplicate
              ? 'รายการสินค้าได้ถูกคัดลอกแล้ว คุณสามารถแก้ไขและส่งคำขอใหม่ได้'
              : 'เลือกวัตถุดิบที่ต้องการ ระบุจำนวน และส่งคำขอไปยังผู้จัดการ'}
          </p>
        </Col>
      </Row>

      {isDuplicate && (
        <Alert variant="info" className="mb-3">
          <i className="bi bi-info-circle me-2"></i>
          <strong>คำสั่งซื้อถูกคัดลอกแล้ว:</strong> รายการสินค้าและจำนวนได้ถูกคัดลอกมาจากคำสั่งซื้อเดิม คุณสามารถแก้ไขได้ตามต้องการ
        </Alert>
      )}

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      <Row>
        <Col md={12}>
          <OrderForm
            initialSelectedMaterials={initialMaterials}
            onSubmit={handleSubmit}
            loading={loading}
            submitButtonText="ส่งคำขอสั่งซื้อ"
            submitButtonIcon="bi-send"
            allowPriceEdit={false}
          />

          <div className="d-grid gap-2 mb-4">
            <Button
              type="button"
              variant="outline-secondary"
              onClick={() => navigate('/')}
            >
              <i className="bi bi-x-circle me-2"></i>
              ยกเลิก
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default OrderCreate;
